export const STORE_LOGO_URL =
  process.env.REACT_APP_STORE_LOGO_URL ||
  'https://tienda.vinogenes.es/images/logo-circular.png';

export function buildOrderConfirmationHtml(order) {
  const customerName = order.shippingAddress?.name || order.customerName || 'Cliente';
  const customerEmail = order.shippingAddress?.email || order.customerEmail || '';
  const subtotal = Number(order.subtotal) || 0;
  const shipping = Number(order.shipping) || 0;
  const total = Number(order.total) || 0;
  const discount = Number(order.discount) || 0;

  const itemsHtml = (order.items || [])
    .map(
      (item) => `
        <tr>
          <td style="padding: 8px; border-bottom: 1px solid #eee;">${item.wineName || item.name}</td>
          <td style="padding: 8px; border-bottom: 1px solid #eee; text-align: center;">${item.quantity}</td>
          <td style="padding: 8px; border-bottom: 1px solid #eee; text-align: right;">
            ${(Number(item.price) * Number(item.quantity)).toFixed(2)} €
          </td>
        </tr>`
    )
    .join('');

  const address = order.shippingAddress || {};

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body style="margin:0;padding:0;background:#f5f5f5;font-family:Arial,sans-serif;color:#333;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#f5f5f5;padding:24px 0;">
    <tr>
      <td align="center">
        <table role="presentation" width="600" cellspacing="0" cellpadding="0" style="max-width:600px;width:100%;background:#ffffff;border-radius:8px;overflow:hidden;">
          <tr>
            <td style="background:#ffffff;padding:28px 24px 16px;text-align:center;border-bottom:3px solid #722F37;">
              <img src="${STORE_LOGO_URL}" alt="Vinogenes" width="140" style="display:block;margin:0 auto 12px;max-width:140px;height:auto;" />
              <h1 style="margin:0;font-size:22px;color:#722F37;font-weight:600;">Confirmación de pedido</h1>
            </td>
          </tr>
          <tr>
            <td style="padding:24px;">
              <p style="margin:0 0 16px;">Hola <strong>${customerName}</strong>,</p>
              <p style="margin:0 0 20px;">Gracias por tu compra en Vinogenes. Tu pedido ha sido confirmado correctamente.</p>

              <div style="background:#fafafa;border:1px solid #eee;border-radius:6px;padding:16px;margin-bottom:20px;">
                <p style="margin:0 0 8px;"><strong>Pedido #${order.id}</strong></p>
                <p style="margin:0;color:#666;font-size:14px;">Email: ${customerEmail}</p>
              </div>

              <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse:collapse;margin-bottom:20px;">
                <thead>
                  <tr style="background:#f0f0f0;">
                    <th style="padding:10px;text-align:left;">Producto</th>
                    <th style="padding:10px;text-align:center;">Cant.</th>
                    <th style="padding:10px;text-align:right;">Subtotal</th>
                  </tr>
                </thead>
                <tbody>${itemsHtml}</tbody>
                <tfoot>
                  <tr>
                    <td colspan="2" style="padding:8px;text-align:right;"><strong>Subtotal:</strong></td>
                    <td style="padding:8px;text-align:right;"><strong>${subtotal.toFixed(2)} €</strong></td>
                  </tr>
                  <tr>
                    <td colspan="2" style="padding:8px;text-align:right;"><strong>Envío:</strong></td>
                    <td style="padding:8px;text-align:right;"><strong>${shipping === 0 ? 'Gratis' : `${shipping.toFixed(2)} €`}</strong></td>
                  </tr>
                  ${
                    discount > 0
                      ? `<tr>
                    <td colspan="2" style="padding:8px;text-align:right;"><strong>Descuento:</strong></td>
                    <td style="padding:8px;text-align:right;"><strong>-${discount.toFixed(2)} €</strong></td>
                  </tr>`
                      : ''
                  }
                  <tr style="background:#f0f0f0;">
                    <td colspan="2" style="padding:12px;text-align:right;"><strong>TOTAL:</strong></td>
                    <td style="padding:12px;text-align:right;"><strong>${total.toFixed(2)} €</strong></td>
                  </tr>
                </tfoot>
              </table>

              <div style="background:#fafafa;border:1px solid #eee;border-radius:6px;padding:16px;margin-bottom:20px;">
                <p style="margin:0 0 8px;font-weight:600;">Dirección de envío</p>
                <p style="margin:0;line-height:1.6;">
                  ${address.name || customerName}<br>
                  ${address.street || ''}<br>
                  ${address.city || ''}, ${address.postalCode || ''}<br>
                  ${address.province || ''}<br>
                  ${address.phone ? `Tel: ${address.phone}` : ''}
                </p>
              </div>

              <p style="margin:0 0 8px;">Si tienes alguna consulta, escríbenos a <a href="mailto:pedidos@vinogenes.es" style="color:#722F37;">pedidos@vinogenes.es</a>.</p>
              <p style="margin:0;">¡Gracias por elegir Vinogenes!</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
}
